import { useContext, useState } from "react";
import { UPSContext } from "@app/provider";
import { HEAP_EVENTS } from "@app/provider/types";
import { UPSNotificationTemplate } from "@app/hooks/useGeneratedTokenizedLink";

interface TrackUPSHeapEventProps {
  eventKey: HEAP_EVENTS;
}

const useUPSHeapEvent = (): {
  trackUPSHeapEvent: ({ eventKey }: TrackUPSHeapEventProps) => void;
} => {
  const [isFirstCall, setIsFirstCall] = useState(true);

  const { upsPatientUid } = useContext(UPSContext);

  if (isFirstCall && upsPatientUid) {
    // TODO: make sure other events for ups, pre-bill and post-bill sets heap.identify()
    heap.identify(upsPatientUid!);
    setIsFirstCall(false);
  }

  const trackUPSHeapEvent = ({ eventKey }: TrackUPSHeapEventProps) => {
    const heapEventData = {
      notification_type: UPSNotificationTemplate.UPS_COMM,
      identity: upsPatientUid,
    };

    heap.track(eventKey, heapEventData);
  };

  return { trackUPSHeapEvent };
};

export default useUPSHeapEvent;
